<div>
    <h2 *ngIf="data.title">{{data.title}}</h2>
    <mat-spinner diameter="50"></mat-spinner>
    <p *ngIf="data.text">{{data.text}}</p>
</div>